import { FunctionComponent } from 'react'

import styled from 'styled-components'

import config from '@config'

const {
  subscriptions: { footerBannerClassname },
} = config

const StyledPianoFooterBanner = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  z-index: 10000000;
`

const PianoFooterBanner: FunctionComponent = () => (
  // We need a classname to tell Piano where to display the content of the banner
  <StyledPianoFooterBanner className={`${footerBannerClassname}`} />
)

export default PianoFooterBanner
